// Categories de flux de la map : source unique pour le classement des traitements
// et l'aide "?" de la map (BI-679). Classement sur le filename (stable), pas sur le libelle.

export const CATEGORIES = ["EXTRACTIONS", "GET", "PUT", "IMPORT", "AUTRES"];

// Ordre = priorite : le premier motif qui correspond gagne (insensible a la casse).
export const REGLES_CATEGORIES = [
  {
    categorie: "EXTRACTIONS",
    motifs: ["iCTI_extraction_*", "iCTI_PUSH_extractions_*"],
    regexes: [/^icti_extraction_/i, /^icti_push_extractions_/i],
  },
  {
    categorie: "GET",
    motifs: ["*_prodsgbd_get_*", "iCTI_synchronize_ftp_get*"],
    regexes: [/_prodsgbd_get_/i, /^icti_synchronize_ftp_get/i],
  },
  {
    categorie: "PUT",
    motifs: ["*_prodsgbd_put_*"],
    regexes: [/_prodsgbd_put_/i],
  },
  {
    categorie: "IMPORT",
    motifs: ["iCTI_import_*", "iCTI_load_csv_*", "*_prodsgbd_load_*_csv"],
    regexes: [/^icti_import_/i, /^icti_load_csv_/i, /_prodsgbd_load_.*_csv$/i],
  },
];

export const CATEGORIE_DEFAUT = "AUTRES";

// Ordre d'affichage (pastilles, colonnes de la matrice, lentille, sous-cadres) : distinct de
// l'ordre de priorite des regles ci-dessus.
export const CATEGORIES_AFFICHAGE = ["GET", "PUT", "IMPORT", "EXTRACTIONS", "AUTRES"];

// Palette des categories (identique au prototype valide).
export const COULEURS_CATEGORIES = {
  GET: "#195c84",
  PUT: "#14a3a3",
  IMPORT: "#7c5cff",
  EXTRACTIONS: "#ff8801",
  AUTRES: "#8c98a4",
};
export const COULEUR_KIWEE = "#6d28d9";

export function categorieFlux(filename) {
  if (typeof filename !== "string" || !filename) return CATEGORIE_DEFAUT;
  const regle = REGLES_CATEGORIES.find((r) =>
    r.regexes.some((re) => re.test(filename))
  );
  return regle ? regle.categorie : CATEGORIE_DEFAUT;
}

export function estKiwee(filename) {
  return typeof filename === "string" && /kiwee/i.test(filename);
}

// Nom de fichier d'un job : filename du back, sinon repli sur le libelle (name).
export function filenameJob(job) {
  if (!job) return "";
  return job.filename || job.name || "";
}

export const REMARQUE_KIWEE =
  "*kiwee* : badge KIWEE sur le traitement et filtre KIWEE (la catégorie reste inchangée)";

// Lignes pour le popover d'aide : { categorie, motifs: [string] } + notes.
export const aideCategories = () => ({
  titre: "Règles de catégorisation des flux",
  regles: [
    ...REGLES_CATEGORIES.map((r) => ({
      categorie: r.categorie,
      motifs: r.motifs,
      // Kiwee se greffe sur les extractions (ex. iCTI_extraction_kiwee_*) sans changer la categorie.
      ...(r.categorie === "EXTRACTIONS" ? { remarque: REMARQUE_KIWEE } : {}),
    })),
    {
      categorie: CATEGORIE_DEFAUT,
      motifs: ["tout le reste (pull_data, push_data, push_system, techniques)"],
    },
  ],
  notes: [
    "Classement sur le nom de fichier du traitement, insensible à la casse ; le premier motif qui correspond gagne (dans l'ordre ci-dessus).",
    "KIWEE : badge ajouté quand le nom de fichier contient « kiwee » (catégorie inchangée) ; filtrable avec la pastille « KIWEE ».",
  ],
});
